import _ from 'lodash';
import { createReduxStore } from '#packages/apilib';

import type { Gap } from './resizeGapsTypes';

interface State {
  gap: Gap | null;
  isResizing: boolean;
}

const getInitialState = (): State => ({
  gap: null,
  isResizing: false,
});

export const ResizeGapsStore = createReduxStore({
  getInitialState,
  selectors: {
    getIsResizing: (state) => state.isResizing,
    getGap: (state) => state.gap,
  },
  actions: {
    setGap: (state: State, gap: Gap) => ({ ...state, gap }),
    clearGap: (state: State) => ({ ...state, gap: null }),
    setGapHeight: (state: State, height: number) =>
      _.set(_.cloneDeep(state), 'gap.layout.height', height),
    setIsResizing: (state: State, isResizing: boolean) => ({
      ...state,
      isResizing,
    }),
  },
});
